import { IconClose, IconMenu } from '@americanexpress/dls-icons';
import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { useIsLoggedIn, useNavigationLinksHook } from '../../apiHooks/apiHooks';
import dlsStyles from '../../styles/dls.css';
import styles from '../TravelHeader.scss';
import ProfileDrawerTitleSection from '../ProfileDrawer/ProfileDrawerTitleSection';
import { useIsCenturion } from '../../apiHooks/membershipHooks';
import { useGetProfileLinksForMobile } from '../../apiHooks/navigationHooks';
import { appendQueryToUrl } from '../../utils/navigationUtils';
import ColumnContent from '../ColumnContent/ColumnContent';

const Mobile = () => {
  const { data: navigationLinks } = useNavigationLinksHook();
  const { data: isLoggedIn } = useIsLoggedIn();
  const { formatMessage } = useIntl();
  const isCenturion = useIsCenturion();
  const profileLinkToShow = useGetProfileLinksForMobile();
  return (
    <div className={`mobile ${dlsStyles.body} ${dlsStyles['hidden-lg-up']}`} data-testid="mobileNav">
      <nav className={`${isCenturion ? dlsStyles['dls-black-bg'] : dlsStyles['dls-bright-blue-bg']} ${dlsStyles['dls-white']}`}>
        <div className={`${dlsStyles.container} ${dlsStyles['nav-header']} ${styles.mobileHeader}`}>
          <a href={navigationLinks?.generalLinks.atoLink} className={clsx(dlsStyles.flex, dlsStyles['margin-r'], styles.focusLink)}>
            <img
                // @ts-expect-error -- fetchpriority exists
              fetchPriority="high"
              src={navigationLinks?.generalLinks.travelLogoDesktopSrcUrl}
              alt={formatMessage({ id: 'amexTravel.logo.altText' })}
            />
          </a>
          <div className={`${dlsStyles.flex} ${dlsStyles['flex-align-center']}`}>
            <button
              type="button"
              id="burgerMenuButton"
              className={clsx(styles.burgerMenu, styles.focusLink)}
              aria-expanded="false"
            >
              <IconMenu
                color="white"
                size="md"
                isFilled={true}
                title="menu icon"
                titleId="menu-icon"
              />
              <IconClose
                color="white"
                size="md"
                isFilled={true}
                title="close icon"
                titleId="close-icon"
              />
            </button>
            <div
              className={`${dlsStyles.nav} ${dlsStyles['nav-vertical']} nav-chevron ${styles.mobileNav}`}
              style={{ display: 'none' }}
              id="profile-drawer-dropdown"
            >
              <ProfileDrawerTitleSection />
              <ul
                className={`${dlsStyles['nav-menu']} ${dlsStyles['margin-1-t']} ${dlsStyles['pad-0-l']}
                ${dlsStyles['pad-4-b']} ${dlsStyles['scroll-y']} ${dlsStyles['border-t']} ${dlsStyles['margin-t']}`}
                data-nav-has-dropdowns="true"
                id="tlsMobileNavLinksList"
              >
                {navigationLinks?.mainNavigation
                    && navigationLinks.mainNavigation.map((menuItem, index) => (
                      <li className={clsx(dlsStyles['nav-item'], styles.navItem)} key={menuItem.key} data-testid={`mobileNavItem-${index}`}>
                        {menuItem.url ? (
                          <a
                            href={appendQueryToUrl(menuItem.url, menuItem.linknav)}
                          >
                            <span>{menuItem.label}</span>
                          </a>
                        ) : (
                          <button
                            type="button"
                            className={`${dlsStyles['nav-link']} ${dlsStyles.caret} ${dlsStyles['pad-1']}`}
                            aria-current="false"
                            aria-expanded="false"
                            aria-haspopup="listbox"
                          >
                            <span>{menuItem.label}</span>
                          </button>
                        )}
                        {menuItem.columns.length > 0 && (
                        <ColumnContent menuItem={menuItem} />
                        )}
                      </li>
                    ))}
                {profileLinkToShow.map((link, key) => (
                  <li key={link.label} className={styles.navItem} data-testid={`profileLink-${key}`}>
                    <a
                      href={appendQueryToUrl(link.url, link.linknav)}
                      key={link.label}
                    >
                      <span>{link.label}</span>
                    </a>
                  </li>
                ))}
                {isLoggedIn && navigationLinks?.features.loginLogout === 'true' && (
                  <li className={styles.navItem}>
                    <a href={navigationLinks?.generalLinks?.logout} id="mobileLogout">
                      <span>{formatMessage({ id: 'logout' })}</span>
                    </a>
                  </li>
                )}
                <li className={`${dlsStyles.flex} ${dlsStyles['flex-justify-center']} ${dlsStyles['pad-3-tb']} ${dlsStyles['body-1']}`}>
                  <a
                    href={navigationLinks?.generalLinks.amexHomePageUrl}
                    className={styles.backToAmex}
                    id="backToAmexLink"
                  >
                    <span className={`${dlsStyles.flex} ${dlsStyles['flex-column']}`}>
                      <img src={`${navigationLinks?.generalLinks.amexLogoSrcUrl}`} alt="" />
                      {formatMessage({ id: 'back.to.amex' })}
                    </span>
                  </a>
                </li>
              </ul>
            </div>

            {!isLoggedIn && navigationLinks?.features.loginLogout === 'true' && (
              <a
                href={navigationLinks?.generalLinks.login}
                className={clsx(styles.loginButton, styles.focusLink)}
                id="mobileLogin"
              >
                {formatMessage({ id: 'login' })}
              </a>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Mobile;
